(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ragna-invest-popup"]) return;
  try {
    
  if (!customElements.get('ragna-invest-popup')) {
    customElements.define('ragna-invest-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.storageKey = 'ragna-invest-capital-2026-v1';
        this.editor = this.dataset.editor === 'true';
        this.frequency = Math.max(1, Number(this.dataset.frequency) || 1) * 86400000;
        this.attempts = 0;
        this.querySelectorAll('[data-ragna-close]').forEach((button) => {
          button.addEventListener('click', () => this.dialog.close(), options);
        });
        this.querySelector('[data-ragna-link]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => this.restoreScroll(), options);
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const items = Array.from(this.dialog.querySelectorAll('button:not([disabled]), a[href]'));
          const first = items[0];
          const last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        if (this.editor) {
          this.closest('.shopify-section')?.addEventListener('shopify:section:select', () => this.showPopup(), options);
          this.closest('.shopify-section')?.addEventListener('shopify:section:deselect', () => this.dialog.close(), options);
        }
        this.timer = window.setTimeout(() => this.showPopup(), this.editor ? 300 : Math.max(0, Number(this.dataset.delay) || 0));
      }

      readLastShown() {
        let latest = Number(window.__ragnaInvestLastShown) || 0;
        for (const name of ['localStorage', 'sessionStorage']) {
          try { latest = Math.max(latest, Number(window[name].getItem(this.storageKey)) || 0); } catch {}
        }
        return latest;
      }

      rememberShown() {
        const now = Date.now();
        window.__ragnaInvestLastShown = now;
        for (const name of ['localStorage', 'sessionStorage']) {
          try { window[name].setItem(this.storageKey, String(now)); } catch {}
        }
      }

      showPopup() {
        window.clearTimeout(this.timer);
        if (!this.isConnected || this.dialog.open) return;
        if (!this.editor && Date.now() - this.readLastShown() < this.frequency) return;
        const otherDialog = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).some((element) => {
          return element !== this.dialog && element.getClientRects().length && window.getComputedStyle(element).visibility !== 'hidden';
        });
        const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        if (document.hidden || otherDialog || editing) {
          if (this.attempts++ < 60) this.timer = window.setTimeout(() => this.showPopup(), 1000);
          return;
        }
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        if (!this.editor) this.rememberShown();
      }

      restoreScroll() {
        if (!this.scrollLocked) return;
        if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        if (this.dialog?.open) this.dialog.close();
        this.restoreScroll();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
